import React from 'react';
import { Alert, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import Container from './DroppableContainer';
import * as Settings from '../store/Settings';


class UserSettingsInternal extends React.Component {

    constructor(props) {
        super(props);

		this.state = {
			columnsUsed: this.props.settingsState.columnsUsed,
			columnsIgnored: this.props.settingsState.columnsIgnored,
            allFetched: false,
			doListRefresh: true,
			saving: false,
		};

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.initialize = this.initialize.bind(this);
	}

    componentDidMount() {
		Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
		this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
		if ( this.state.doListRefresh ) {
			this.setState({ doListRefresh: false });
		}
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.allFetched)) {
			this.fetchData();
            this.setState({
                allFetched: true
            });
        }
    }

	fetchData() {
		(async () => {
			await this.props.settingsDispatch.getAll();
		})().then(() => {
			this.setState({
				columnsUsed: this.props.settingsState.columnsUsed,
				columnsIgnored: this.props.settingsState.columnsIgnored,
				doListRefresh: true,
			})
		});
	}

    handleSave() {
        const lst = this.props.settingsState;
		this.props.settingsDispatch.updateSettings( this.state.name, lst );
		this.setState({ saving: true });
		setTimeout(() => { this.setState({ saving: false }); }, 2000);
	}

    handleCancel() {
		(async () => {
			await this.props.settingsDispatch.getAll();
		 })().then(() => {
			this.setState({
				columnsUsed: this.props.settingsState.columnsUsed,
				columnsIgnored: this.props.settingsState.columnsIgnored,
				doListRefresh: true,
			})
		 });
	}

    render() {
        if (!Accounts.authenticatedAllRoles(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const save = "Save";
        const cancel = "Cancel";

		if ( (this.state.columnsIgnored && this.state.columnsIgnored.length > 0) || (this.state.columnsUsed && this.state.columnsUsed.length > 0) ) {
			return (
				<div>
					<h1>User Settings</h1>

					<div className="group-border">
						<h2 className="center"> Columns Displayed when Selecting Records </h2>
						<div className="center"> Usage:
								&nbsp;
								&uarr; Drag to Sort &darr;
								&nbsp;
								&nbsp;
								&nbsp;
								&nbsp;
								&larr; Drag between &rarr;
						</div>
						<div className="settingsColumns">
							<div className="gap-bottom">
								<h3> Columns to Use </h3>
								<Container id={1} refresh={this.state.doListRefresh} name="columnsUsed" list={this.state.columnsUsed} />
							</div>

							<div className="gap-bottom">
								<h3> Columns to Ignore </h3>
								<Container id={2} refresh={this.state.doListRefresh} name="columnsIgnored" list={this.state.columnsIgnored} />
							</div>
						</div>
						<Alert className={this.state.saving ? "animated fadeOut center" : "hidden"}>
							<p>
							Saving...
							</p>
						</Alert>
						<div className={this.state.saving ? "hidden" : "center"}>
							<Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
							&nbsp;
							<Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>{' '}
						</div>
						<div className="gap-bottom" />
					</div>
				</div>
			);
		} else {
			return (
					<div className="gap gap-bottom center vertically-center"> Querying User Settings... </div>
					);
		}
    }
}

const SettingsConnect = connect(
    state => ({
        accountsState: state.accounts,
        settingsState: state.settings
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        settingsDispatch: bindActionCreators(Settings.actionCreators, dispatch)
    })
)(UserSettingsInternal);

export default class UserSettings extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <SettingsConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UserSettings.js